<template>
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar elevation-4 sidebar-dark-marron">
        <a href="#" class="brand-link animation__shake wow fadeInDown"
            style="align-items: center;position: absolute;top: 25px;" data-widget="pushmenu" role="button">
            <center>
                <i class="fas fa-align-right text-white"></i>&nbsp;<img src="../../../assets/img/logojateng.png"
                    alt="Admin Logo" class="animation__shake wow fadeInDown" style="opacity: .8;height: 35px;">
            </center>
        </a>
        <!-- Sidebar -->
        <div class="sidebar wow fadeInLeft">
            <!-- Sidebar Menu -->
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column nav-flat" data-widget="treeview" role="menu"
                    data-accordion="false">
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">
                        <router-link to="/Dashboard"
                            :class="[(route.name == 'Dashboard' ? 'nav-link active' : 'nav-link')]" id="Dashboard"><i
                                class="nav-icon fas fa-home"></i>
                            <p>DASHBOARD</p>
                        </router-link>
                    </li>
                    <li class="nav-item" v-if="leveluser == 10">
                        <router-link to="/Konsultan"
                            :class="[(route.name == 'Konsultan' || route.name == 'ProsesKurvaSKonsultan' || route.name == 'KendalaTindakLanjutKonsultan' ? 'nav-link active' : 'nav-link')]"
                            id="Konsultan"><i class="nav-icon fas fa-chart-line"></i>
                            <p>KURVA S</p>
                        </router-link>
                    </li>
                    <li v-if="leveluser == 1 || leveluser == 2 || leveluser == 3 || leveluser == 4 || leveluser == 5 || leveluser == 6 || leveluser == 7 || leveluser == 8 || leveluser == 9"
                        :class="[((route.name == 'Inbox' || route.name == 'ProsesInbox' || route.name == 'Kalendar' || route.name == 'ProsesKalendar' || route.name == 'ViewKalendar') ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#"
                            :class="[((route.name == 'Inbox' || route.name == 'ProsesInbox' || route.name == 'Kalendar' || route.name == 'ProsesKalendar' || route.name == 'ViewKalendar') ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-desktop"></i>
                            <p>
                                AGENDA TIM
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item"
                                v-if="leveluser == 1 || leveluser == 2 || leveluser == 3 || leveluser == 4 || leveluser == 5 || leveluser == 6 || leveluser == 7 || leveluser == 8 || leveluser == 9">
                                <router-link to="/Inbox"
                                    :class="[((route.name == 'Inbox' || route.name == 'ProsesInbox') ? 'nav-link active' : 'nav-link')]"
                                    id="Inbox"><i class="nav-icon fas fa-inbox"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Data</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="leveluser == 1 || leveluser == 2 || leveluser == 3 || leveluser == 4 || leveluser == 5 || leveluser == 6 || leveluser == 7 || leveluser == 8 || leveluser == 9">
                                <router-link to="/Kalendar"
                                    :class="[((route.name == 'Kalendar' || route.name == 'ProsesKalendar' || route.name == 'ViewKalendar') ? 'nav-link active' : 'nav-link')]"
                                    id="Kalendar"><i class="nav-icon fas fa-calendar-alt"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Agenda</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-if="leveluser == 1 || leveluser == 2 || leveluser == 3 || leveluser == 4 || leveluser == 5 || leveluser == 6 || leveluser == 7 || leveluser == 8 || leveluser == 9"
                        :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'ProsesPDOMonev' || route.name == 'ProsesKurvaS' || route.name == 'KendalaTindakLanjut' || route.name == 'CEMP' || route.name == 'Sampel' || route.name == 'RKLRPL' || route.name == 'IPP' || route.name == 'GAP' || route.name == 'PDOIOS' || route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat' || route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial' || route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM' || route.name == 'PDO3' || route.name == 'PDO11' || route.name == 'PDO3Rapat') ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#"
                            :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'ProsesPDOMonev' || route.name == 'ProsesKurvaS' || route.name == 'KendalaTindakLanjut' || route.name == 'CEMP' || route.name == 'Sampel' || route.name == 'RKLRPL' || route.name == 'IPP' || route.name == 'GAP' || route.name == 'PDOIOS' || route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat' || route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial' || route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM' || route.name == 'PDO3' || route.name == 'PDO11' || route.name == 'PDO3Rapat') ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-server"></i>
                            <p>
                                MONITORING
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="roleuser == 'admin'" style="display: none;">
                                <router-link to="/PDOIOS"
                                    :class="[((route.name == 'PDOIOS' || route.name == 'ProsesPDOIOS') ? 'nav-link active' : 'nav-link')]"
                                    id="PDOIOS"><i class="nav-icon fab fa-dashcube"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PDO & IOS (Key performance indicator)
                                    </p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1 || leveluser == 4">
                                <router-link :to="'/Monev/' + halamanawal"
                                    :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'ProsesPDOMonev' || route.name == 'ProsesKurvaS' || route.name == 'KendalaTindakLanjut' || route.name == 'PDO3' || route.name == 'PDO11' || route.name == 'PDO3Rapat') ? 'nav-link active' : 'nav-link')]"
                                    id="Monev"><i class="nav-icon fas fa-atom"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Paket Pekerjaan</p>
                                </router-link>
                            </li>
                            <li v-if="leveluser == 1 || leveluser == 3"
                                :class="[((route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-item menu-open' : 'nav-item')]">
                                <a href="#" style="font-size: smaller;color: #ffffff;"
                                    :class="[((route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-link active' : 'nav-link')]">
                                    <i class="nav-icon fas fa-money-bill"></i>
                                    <p>
                                        FINANCE
                                        <i class="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 3" style="display: none;">
                                        <router-link :to="'/DashboardFinance/' + halamanawal"
                                            :class="[((route.name == 'DashboardFinance') ? 'nav-link active' : 'nav-link')]"
                                            id="DashboardFinance"><i class="nav-icon fab fa-buromobelexperte"
                                                style="font-size: smaller;color: #ffffff;"></i>
                                            <p style="font-size: smaller;color: #ffffff;">Dashboard Finance</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 3">
                                        <router-link :to="'/Finance/' + halamanawal"
                                            :class="[((route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-link active' : 'nav-link')]"
                                            id="Finance"><i class="nav-icon fas fa-money-bill-wave"
                                                style="font-size: smaller;color: #ffffff;"></i>
                                            <p style="font-size: smaller;color: #ffffff;">OWP, AWP, DIPA, Realisasi</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li v-if="leveluser == 1 || leveluser == 2 || leveluser == 6 || leveluser == 7"
                                :class="[((route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial') ? 'nav-item menu-open' : 'nav-item')]">
                                <a href="#" style="font-size: smaller;color: #ffffff;"
                                    :class="[((route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial') ? 'nav-link active' : 'nav-link')]">
                                    <i class="nav-icon fas fa-house-user"></i>
                                    <p>
                                        SAFEGUARD
                                        <i class="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 7">
                                        <router-link :to="'/Environment/' + halamanawal"
                                            :class="[((route.name == 'Environment' || route.name == 'ProsesEnvironment') ? 'nav-link active' : 'nav-link')]"
                                            id="Environment"><i class="nav-icon fas fa-tint"
                                                style="font-size: smaller;color: #ffffff;"></i>
                                            <p style="font-size: smaller;color: #ffffff;">Environmental</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 2 || leveluser == 6">
                                        <router-link :to="'/Social/' + halamanawal"
                                            :class="[((route.name == 'Social' || route.name == 'ProsesSocial') ? 'nav-link active' : 'nav-link')]"
                                            id="Social"><i class="nav-icon far fa-id-card"
                                                style="font-size: smaller;color: #ffffff;"></i>
                                            <p style="font-size: smaller;color: #ffffff;">Social</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li v-if="leveluser == 1 || leveluser == 2 || leveluser == 9 || leveluser == 6"
                                :class="[((route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat') ? 'nav-item menu-open' : 'nav-item')]">
                                <a href="#" style="font-size: smaller;color: #ffffff;"
                                    :class="[((route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat') ? 'nav-link active' : 'nav-link')]">
                                    <i class="nav-icon fas fa-cogs"></i>
                                    <p>
                                        ADUAN
                                        <i class="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item"
                                        v-if="leveluser == 1 || leveluser == 2 || leveluser == 9 || leveluser == 6">
                                        <router-link :to="'/AduanMasyarakat/' + halamanaduan"
                                            :class="[((route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat') ? 'nav-link active' : 'nav-link')]"
                                            id="AduanMasyarakat"><i class="nav-icon fab fa-adn"
                                                style="font-size: smaller;color: #ffffff;"></i>
                                            <p style="font-size: smaller;color: #ffffff;">Data Aduan</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/CEMP"
                                    :class="[((route.name == 'CEMP' || route.name == 'ProsesCEMP') ? 'nav-link active' : 'nav-link')]"
                                    id="CEMP"><i class="nav-icon fab fa-audible"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PERLINDUNGAN LINGKUNGAN (CEMP)</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/Sampel"
                                    :class="[((route.name == 'Sampel' || route.name == 'ProsesSampel') ? 'nav-link active' : 'nav-link')]"
                                    id="Sampel"><i class="nav-icon fas fa-cog"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PERLINDUNGAN LINGKUNGAN (PENGAMBILAN
                                        SAMPEL)</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/RKLRPL"
                                    :class="[((route.name == 'RKLRPL' || route.name == 'ProsesRKLRPL') ? 'nav-link active' : 'nav-link')]"
                                    id="RKLRPL"><i class="nav-icon far fa-clipboard"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PERLINDUNGAN LINGKUNGAN (RKL - RPL)
                                    </p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/IPP"
                                    :class="[((route.name == 'IPP' || route.name == 'ProsesIPP') ? 'nav-link active' : 'nav-link')]"
                                    id="IPP"><i class="nav-icon fab fa-codepen"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PROGRESS OF SOCIAL SAFEGUARD
                                        (INDIGENOUS PEOPLE & GENDER)</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/GAP"
                                    :class="[((route.name == 'GAP' || route.name == 'ProsesGAP') ? 'nav-link active' : 'nav-link')]"
                                    id="GAP"><i class="nav-icon fab fa-dashcube"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">GENDER ACTION PLAN</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-if="leveluser < 9" :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'Slider'
                        || route.name == 'ProsesSlider' || route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda'
                        || route.name == 'Konten' || route.name == 'ProsesKonten'
                        || route.name == 'TimPelaksana' || route.name == 'ProsesTimPelaksana'
                        || route.name == 'Berita' || route.name == 'ProsesBerita'
                        || route.name == 'KategoriData' || route.name == 'ProsesKategoriData'
                        || route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta'
                        || route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri'
                        || route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen'
                        || route.name == 'DataDokumen' || route.name == 'SettingMenu') ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#" :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'Slider'
                            || route.name == 'ProsesSlider' || route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda'
                            || route.name == 'Konten' || route.name == 'ProsesKonten'
                            || route.name == 'TimPelaksana' || route.name == 'ProsesTimPelaksana'
                            || route.name == 'Berita' || route.name == 'ProsesBerita'
                            || route.name == 'KategoriData' || route.name == 'ProsesKategoriData'
                            || route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta'
                            || route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri'
                            || route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen'
                            || route.name == 'DataDokumen' || route.name == 'SettingMenu') ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-tablets"></i>
                            <p>
                                PENGATURAN
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Kategori"
                                    :class="[((route.name == 'Kategori' || route.name == 'ProsesKategori') ? 'nav-link active' : 'nav-link')]"
                                    id="Kategori"><i class="nav-icon fas fa-bahai"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">KATEGORI DATA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/SubKategori"
                                    :class="[((route.name == 'SubKategori' || route.name == 'ProsesSubKategori') ? 'nav-link active' : 'nav-link')]"
                                    id="SubKategori"><i class="nav-icon fab fa-bandcamp"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">SUB KATEGORI DATA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/UnitKategori"
                                    :class="[((route.name == 'UnitKategori' || route.name == 'ProsesUnitKategori') ? 'nav-link active' : 'nav-link')]"
                                    id="UnitKategori"><i class="nav-icon fab fa-bitbucket"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">UNIT KATEGORI DATA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/Slider"
                                    :class="[((route.name == 'Slider' || route.name == 'ProsesSlider') ? 'nav-link active' : 'nav-link')]"
                                    id="Slider"><i class="nav-icon fas fa-camera"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Slider Gambar</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/InfoBeranda"
                                    :class="[((route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda') ? 'nav-link active' : 'nav-link')]"
                                    id="InfoBeranda"><i class="nav-icon fas fa-box"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Info Beranda</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/Konten"
                                    :class="[((route.name == 'Konten' || route.name == 'ProsesKonten') ? 'nav-link active' : 'nav-link')]"
                                    id="Konten"><i class="nav-icon fas fa-book"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Konten Web</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/TimPelaksana"
                                    :class="[((route.name == 'TimPelaksana' || route.name == 'ProsesTimPelaksana') ? 'nav-link active' : 'nav-link')]"
                                    id="TimPelaksana"><i class="nav-icon fas fa-address-card"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Tim Pelaksana NUFReP</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1 && leveluser <= 1">
                                <router-link to="/Berita"
                                    :class="[((route.name == 'Berita' || route.name == 'ProsesBerita') ? 'nav-link active' : 'nav-link')]"
                                    id="Berita"><i class="nav-icon fas fa-bold"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Berita</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/Galeri"
                                    :class="[((route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri') ? 'nav-link active' : 'nav-link')]"
                                    id="Galeri"><i class="nav-icon fas fa-photo-video"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Galeri</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Dokumen"
                                    :class="[((route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen') ? 'nav-link active' : 'nav-link')]"
                                    id="Dokumen"><i class="nav-icon far fa-file-pdf"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Dokumen</p>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link to="/DataDokumen"
                                    :class="[((route.name == 'DataDokumen') ? 'nav-link active' : 'nav-link')]"
                                    id="DataDokumen"><i class="nav-icon far fa-file-pdf"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Dokumen</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Regulasi"
                                    :class="[((route.name == 'Regulasi' || route.name == 'ProsesRegulasi') ? 'nav-link active' : 'nav-link')]"
                                    id="Regulasi"><i class="nav-icon far fa-file-pdf"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Regulasi</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'" style="display: none;">
                                <router-link to="/KategoriData"
                                    :class="[((route.name == 'KategoriData' || route.name == 'ProsesKategoriData') ? 'nav-link active' : 'nav-link')]"
                                    id="KategoriData"><i class="nav-icon fas fa-boxes"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">KATEGORI DATA PETA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/LayerPeta"
                                    :class="[((route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta') ? 'nav-link active' : 'nav-link')]"
                                    id="LayerPeta"><i class="nav-icon fas fa-layer-group"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Layer Peta</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/SettingMenu"
                                    :class="[((route.name == 'SettingMenu') ? 'nav-link active' : 'nav-link')]"
                                    id="SettingMenu"><i class="nav-icon fas fa-code-branch"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Setting Menu</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1">
                                <router-link to="/User"
                                    :class="[((route.name == 'User' || route.name == 'ProsesUser') ? 'nav-link active' : 'nav-link')]"
                                    id="User"><i class="nav-icon fas fa-user-friends"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Pengguna</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-if="settingabsensistem == 1" :class="[((route.name == 'UserAbsensi' || route.name == 'ProsesUserAbsensi' || route.name == 'HariLibur' || route.name == 'ProsesHariLibur' || route.name == 'PengaturanIzin' || route.name == 'ProsesPengaturanIzin'
                        || route.name == 'LokasiAbsensi' || route.name == 'ProsesLokasiAbsensi' || route.name == 'DataAbsensi' || route.name == 'ProsesDataAbsensi' || route.name == 'ProsesDetailAbsensi'
                    ) ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#" :class="[((route.name == 'UserAbsensi' || route.name == 'ProsesUserAbsensi' || route.name == 'HariLibur' || route.name == 'ProsesHariLibur' || route.name == 'PengaturanIzin' || route.name == 'ProsesPengaturanIzin'
                            || route.name == 'LokasiAbsensi' || route.name == 'ProsesLokasiAbsensi' || route.name == 'DataAbsensi' || route.name == 'ProsesDataAbsensi' || route.name == 'ProsesDetailAbsensi'
                        ) ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-chalkboard-teacher"></i>
                            <p>
                                ABSENSI
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="roleuser == 'admin' && leveluser <= 1" style="display: none;">
                                <router-link to="/Kategori"
                                    :class="[((route.name == 'Kategori' || route.name == 'ProsesKategori') ? 'nav-link active' : 'nav-link')]"
                                    id="Kategori"><i class="nav-icon fas fa-chalkboard"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Dashboard</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="roleuser == 'admin' && leveluser <= 1 && settingabsensistem == 1">
                                <router-link to="/DataAbsensi"
                                    :class="[((route.name == 'DataAbsensi' || route.name == 'ProsesDataAbsensi' || route.name == 'ProsesDetailAbsensi') ? 'nav-link active' : 'nav-link')]"
                                    id="DataAbsensi"><i class="nav-icon far fa-folder-open"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Data Absensi</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="roleuser == 'admin' && leveluser <= 1 && settingabsensistem == 1">
                                <router-link to="/LokasiAbsensi"
                                    :class="[((route.name == 'LokasiAbsensi' || route.name == 'ProsesLokasiAbsensi') ? 'nav-link active' : 'nav-link')]"
                                    id="LokasiAbsensi"><i class="nav-icon fas fa-thumbtack"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Lokasi Absensi</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="roleuser == 'admin' && leveluser <= 1 && settingabsensistem == 1">
                                <router-link to="/PengaturanIzin"
                                    :class="[((route.name == 'PengaturanIzin' || route.name == 'ProsesPengaturanIzin') ? 'nav-link active' : 'nav-link')]"
                                    id="PengaturanIzin"><i class="nav-icon fas fa-tshirt"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Pengajuan Izin & Perjalanan<br>Dinas</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="roleuser == 'admin' && leveluser <= 1 && settingabsensistem == 1">
                                <router-link to="/HariLibur"
                                    :class="[((route.name == 'HariLibur' || route.name == 'ProsesHariLibur') ? 'nav-link active' : 'nav-link')]"
                                    id="HariLibur"><i class="nav-icon fab fa-creative-commons-by"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Pengaturan Hari Libur</p>
                                </router-link>
                            </li>
                            <li class="nav-item"
                                v-if="roleuser == 'admin' && leveluser <= 1 && settingabsensistem == 1">
                                <router-link to="/UserAbsensi"
                                    :class="[((route.name == 'UserAbsensi' || route.name == 'ProsesUserAbsensi') ? 'nav-link active' : 'nav-link')]"
                                    id="Slider"><i class="nav-icon fas fa-child"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">Manajemen Pengguna<br>Absensi</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link" @click="keluar()">
                            <i class="nav-icon fas fa-sign-out-alt"></i>
                            <p>KELUAR / LOGOUT</p>
                        </a>
                    </li>

                    <li>&nbsp;</li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
export default {
    components: {
        swal
    },
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            settingabsensistem: JSON.parse(localStorage.getItem("settingabsensistem")),
            folderawal: encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            halamanaduan: encodeURIComponent(CryptoJS.AES.encrypt('||||||||', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            halamanawal: encodeURIComponent(CryptoJS.AES.encrypt('_1________', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
        };
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                localStorage.removeItem('tokensistem');
                localStorage.removeItem('usistem');
                localStorage.removeItem('lsistem');
                localStorage.removeItem('inssistem');
                localStorage.removeItem('rlsistem');
                localStorage.removeItem('nmlsistem');
                localStorage.removeItem('emlsistem');
                localStorage.removeItem('nmusistem');
                localStorage.removeItem('tsistem');
                localStorage.removeItem('orsistem');
                localStorage.removeItem('bdlsistem');
                localStorage.removeItem('sbdsistem');
                localStorage.removeItem('jbtsistem');
            }
        },
        pindahawalnya1() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data/" + bytes);
        },
        pindahawalnya3() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data3/" + bytes);
        },
        pindahawalnya4() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data4/" + bytes);
        },
        pindahawalnya5() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data5/" + bytes);
        },
        pindahawalnya6() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data6/" + bytes);
        },
        pindahawalnya7() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data7/" + bytes);
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorage();
                }
            });

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        if ((localStorage.getItem("tokensistem") == null)) {
            window.location.replace("/Login");
        }
    }
}
</script>

<style></style>